<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-justify">
          Estimado Ciudadano, de acuerdo a los registros del Servicio Electoral, usted se encuentra en alguno de los casos
          informados anteriormente y que impiden la realización de su solicitud de reclamo.
        </p>
      </div>
    </div>
    <el-divider></el-divider>

    <template v-if="media.sm">
      <div class="row text-center">
        <div class="col">
          <el-button type="danger" @click="endProcess" class="terminar" data-cy="terminar">
            Terminar
          </el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-end">
        <el-button type="danger" @click="endProcess" class="terminar" data-cy="terminar">
          Terminar
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
import {Divider} from "element-ui";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import {RouterMixin} from "@/mixins/routerMixin";

export default {
  name: "ReclamoNoValido",
  components: {
    [Divider.name]: Divider,
  },
  mixins: [
    ScreenSizeMixin,
    RouterMixin
  ],
  methods: {
    endProcess() {
      this.navigate({name: 'resumen-tramites'})
    }
  }
}
</script>

<style scoped>

</style>
